import $ from 'jquery';

// Listeners
$('.SkipToMain').on('click', () => {
  focusOnMain();
});

function focusOnMain() {
  const main = document.querySelectorAll('main')[0];

  const firstElementFocusable = main.querySelectorAll(`
    a[href], area[href], input:not([disabled]), select:not([disabled]), 
    textarea:not([disabled]), button:not([disabled]), iframe, object, 
    embed, [tabindex="0"], [contenteditable]
  `)[0];

  if (firstElementFocusable) firstElementFocusable.focus();
}
